const config = /** @type {const} */ ({
  KEY_HINT_DELAY_MS: 1100,
  KEY_TRIGGER_DELAY_MS: 400,
  ROUNDS_NUMBER: 5,
  DIFFICULTY_ARRAY: ['easy', 'medium', 'hard'],
  LATIN_MAP: {
    Q: 'Q',
    W: 'W',
    E: 'E',
    R: 'R',
    T: 'T',
    Y: 'Y',
    U: 'U',
    I: 'I',
    O: 'O',
    P: 'P',
    A: 'A',
    S: 'S',
    D: 'D',
    F: 'F',
    G: 'G',
    H: 'H',
    J: 'J',
    K: 'K',
    L: 'L',
    Z: 'Z',
    X: 'X',
    C: 'C',
    V: 'V',
    B: 'B',
    N: 'N',
    M: 'M',
  },
  CYRILLIC_MAP: {
    Й: 'Q',
    Ц: 'W',
    У: 'E',
    К: 'R',
    Е: 'T',
    Н: 'Y',
    Г: 'U',
    Ш: 'I',
    Щ: 'O',
    З: 'P',
    Ф: 'A',
    Ы: 'S',
    В: 'D',
    А: 'F',
    П: 'G',
    Р: 'H',
    О: 'J',
    Л: 'K',
    Д: 'L',
    Я: 'Z',
    Ч: 'X',
    С: 'C',
    М: 'V',
    И: 'B',
    Т: 'N',
    Ь: 'M',
  },
  DIGIT_MAP: {
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
  },
});
export default config;
